import { render, staticRenderFns } from "./BuyCredit.vue?vue&type=template&id=3a716bf9&scoped=true"
import script from "./BuyCredit.vue?vue&type=script&lang=js"
export * from "./BuyCredit.vue?vue&type=script&lang=js"
import style0 from "./BuyCredit.vue?vue&type=style&index=0&id=3a716bf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a716bf9",
  null
  
)

export default component.exports